(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-lp-bridge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CODE_PATTERN = /^[a-z0-9]{1,12}$/i;
    var PREFIX_PATTERN = /^\/(?!\/)[a-z0-9\-_\/]*$/i;
    var DEFAULT_PREFIX = '/zum-produkt/';
    var DEFAULT_PARAM = 'p';
    var BRIDGE_MARKER = 'bridge';
    var observers = [];

    function report(error) {
      if (window.Shopify && window.Shopify.designMode && window.console) {
        window.console.warn('[ad-lp-bridge]', error);
      }
    }

    function readCode(param) {
      var value = new URLSearchParams(window.location.search).get(param);
      return value && CODE_PATTERN.test(value) ? value.toLowerCase() : null;
    }

    function configFor(link) {
      var root = link.closest('[data-bridge]') || document.querySelector('[data-bridge]');
      var prefix = (root && root.getAttribute('data-bridge-prefix')) || DEFAULT_PREFIX;
      var param = (root && root.getAttribute('data-bridge-param')) || DEFAULT_PARAM;
      var fallback = (root && root.getAttribute('data-bridge-fallback')) || '';
      if (prefix.charAt(prefix.length - 1) !== '/') prefix += '/';
      return { prefix: prefix, param: param, fallback: fallback };
    }

    function forwardQuery(param) {
      var params = new URLSearchParams(window.location.search);
      params.delete(param);
      params.set(BRIDGE_MARKER, '1');
      return params.toString();
    }

    function fallbackTarget(base, param) {
      if (!base) return '';
      var params = new URLSearchParams(window.location.search);
      params.delete(param);
      params.delete(BRIDGE_MARKER);
      var query = params.toString();
      if (!query) return base;
      return base + (base.indexOf('?') === -1 ? '?' : '&') + query;
    }

    function rewriteLinks() {
      var links = document.querySelectorAll('[data-bridge-link]');
      var targets = [];
      var i;
      for (i = 0; i < links.length; i++) {
        var config = configFor(links[i]);
        var code = PREFIX_PATTERN.test(config.prefix) ? readCode(config.param) : null;
        targets.push(
          code
            ? config.prefix + code + '?' + forwardQuery(config.param)
            : fallbackTarget(config.fallback, config.param)
        );
      }
      for (i = 0; i < links.length; i++) {
        if (targets[i]) links[i].setAttribute('href', targets[i]);
      }
    }

    function watchSticky(sticky) {
      var hero = sticky.closest('[data-bridge-hero]');
      var cta = hero && hero.querySelector('[data-bridge-hero-cta]');
      if (!cta || !('IntersectionObserver' in window)) {
        sticky.classList.add('is-visible');
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
      observer.observe(cta);
      observers.push(observer);
    }

    function initSticky() {
      observers.forEach(function (observer) {
        observer.disconnect();
      });
      observers = [];
      var stickies = document.querySelectorAll('[data-bridge-sticky]');
      for (var i = 0; i < stickies.length; i++) {
        watchSticky(stickies[i]);
      }
    }

    function init() {
      try {
        rewriteLinks();
      } catch (error) {
        report(error);
      }
      try {
        initSticky();
      } catch (error) {
        report(error);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["embed-app-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
    function initOne(root) {
      if (root.dataset.heroBound === '1') return;
      root.dataset.heroBound = '1';
      var videos = root.querySelectorAll('video.video-hero__bg');
      var btn = root.querySelector('.video-hero__toggle');
      if (!videos.length) return;
      var userPaused = RM.matches;
      function anyPlaying() { for (var i = 0; i < videos.length; i++) { if (!videos[i].paused) return true; } return false; }
      function tryPlay(v) { if (userPaused) return; var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
      function setBtn(p) { root.setAttribute('data-playing', p ? 'true' : 'false'); if (btn) { btn.setAttribute('aria-pressed', p ? 'true' : 'false'); btn.setAttribute('aria-label', p ? 'Video pausieren' : 'Video abspielen'); } }
      for (var i = 0; i < videos.length; i++) {
        (function (v) {
          v.addEventListener('play', function () { setBtn(true); });
          v.addEventListener('pause', function () { if (!anyPlaying()) setBtn(false); });
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
              for (var j = 0; j < entries.length; j++) { if (entries[j].isIntersecting) { tryPlay(v); } else { v.pause(); } }
            }, { threshold: 0.2 }).observe(v);
          } else { tryPlay(v); }
        })(videos[i]);
      }
      if (btn) {
        btn.addEventListener('click', function () {
          var vis = null;
          for (var i = 0; i < videos.length; i++) { if (videos[i].offsetParent !== null) { vis = videos[i]; break; } }
          if (!vis) vis = videos[0];
          if (vis.paused) { userPaused = false; tryPlay(vis); }
          else { userPaused = true; for (var k = 0; k < videos.length; k++) { videos[k].pause(); } }
        });
      }
    }
    function init(scope) { var n = (scope || document).querySelectorAll('.video-hero'); for (var i = 0; i < n.length; i++) { initOne(n[i]); } }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glp1-upload"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_SIZE = 15728640;

  function init(root) {
    if (!root || root.dataset.glp1Init) return;
    root.dataset.glp1Init = '1';

    var apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');
    var shopId = root.dataset.shopId || '';
    var customerId = new URLSearchParams(window.location.search).get('customer_id');
    var states = root.querySelectorAll('[data-state]');
    var errEl = root.querySelector('[data-upload-error]');
    var submitBtn = root.querySelector('[data-submit]');
    var uploaded = { id: false, body: false };
    var staged = { id: null, body: null };

    function setState(state) {
      states.forEach(function (el) {
        el.hidden = el.getAttribute('data-state') !== state;
      });
    }

    if (root.dataset.designMode) {
      setState(root.dataset.previewState || 'missing');
      root.querySelectorAll('[data-camera]').forEach(function (btn) {
        btn.hidden = false;
      });
      return;
    }

    if (!customerId) {
      root.hidden = true;
      return;
    }

    function card(kind) {
      return root.querySelector('[data-uploader="' + kind + '"]');
    }

    function clearStagedUI(kind) {
      staged[kind] = null;
      var el = card(kind);
      if (!el) return;
      var box = el.querySelector('[data-staged]');
      if (!box) return;
      var thumb = box.querySelector('.glp1-upload__staged-thumb');
      if (thumb && thumb.src) {
        URL.revokeObjectURL(thumb.src);
        thumb.removeAttribute('src');
      }
      box.hidden = true;
      el.classList.remove('is-staged');
    }

    function markUploaded(kind) {
      clearStagedUI(kind);
      var el = card(kind);
      if (!el) return;
      el.classList.remove('is-loading');
      el.classList.add('is-uploaded');
      var input = el.querySelector('input[type="file"]');
      if (input) input.disabled = true;
      var done = el.querySelector('.glp1-upload__card-done');
      if (done) done.hidden = false;
    }

    var idParams = '?shop_customer_id=' + encodeURIComponent(customerId) + '&shop_identifier=' + encodeURIComponent(shopId);

    function upload(kind, file) {
      var url;
      var formData = new FormData();
      if (kind === 'id') {
        url = apiBase + '/api/v0/patient/id/verification' + idParams;
        formData.append('image', file, file.name || 'foto-id.jpg');
      } else {
        url = apiBase + '/api/v0/patient/properties';
        formData.append('value', file, file.name || 'foto-koerper.jpg');
        formData.append('shop_customer_id', customerId);
        formData.append('shop_identifier', shopId);
        formData.append('field', 'body_picture');
      }

      var el = card(kind);
      if (el) el.classList.add('is-loading');

      return fetch(url, { method: 'POST', body: formData }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.status === 'error') {
            throw new Error('upload failed');
          }
          uploaded[kind] = true;
          markUploaded(kind);
        });
      });
    }

    function stage(kind, file) {
      if (uploaded[kind]) return;
      if (file.size > MAX_SIZE) {
        window.alert(root.dataset.fileSizeError);
        return;
      }
      var el = card(kind);
      if (!el) return;
      var box = el.querySelector('[data-staged]');
      if (!box) return;
      staged[kind] = file;
      var thumb = box.querySelector('.glp1-upload__staged-thumb');
      var fileIcon = box.querySelector('.glp1-upload__staged-file');
      var nameEl = box.querySelector('[data-staged-name]');
      if (thumb.src) {
        URL.revokeObjectURL(thumb.src);
        thumb.removeAttribute('src');
      }
      if (file.type === 'application/pdf') {
        thumb.hidden = true;
        if (fileIcon) fileIcon.hidden = false;
      } else {
        thumb.src = URL.createObjectURL(file);
        thumb.hidden = false;
        if (fileIcon) fileIcon.hidden = true;
      }
      if (nameEl) nameEl.textContent = file.name || (kind === 'id' ? 'foto-id.jpg' : 'foto-koerper.jpg');
      box.hidden = false;
      el.classList.add('is-staged');
      if (errEl) errEl.hidden = true;
      updateSubmit();
    }

    function unstage(kind) {
      clearStagedUI(kind);
      updateSubmit();
    }

    function updateSubmit() {
      if (!submitBtn) return;
      var needed = ['id', 'body'].filter(function (k) { return !uploaded[k]; });
      submitBtn.disabled = !needed.length || !needed.every(function (k) { return staged[k]; });
    }

    function submitAll() {
      var kinds = ['id', 'body'].filter(function (k) { return !uploaded[k] && staged[k]; });
      if (!kinds.length) return;
      if (errEl) errEl.hidden = true;
      if (submitBtn) submitBtn.disabled = true;
      // Sequenziell, NICHT parallel: RxScale schreibt beide Fotos in denselben
      // Patienten-Datensatz. Zwei gleichzeitige POSTs lesen denselben Ausgangsstand
      // und ueberschreiben sich gegenseitig (lost update) -> nur eins bleibt erhalten.
      // Der zweite Upload startet daher erst, wenn der erste bestaetigt ist.
      var failed = false;
      var chain = Promise.resolve();
      kinds.forEach(function (k) {
        chain = chain.then(function () {
          return upload(k, staged[k]).catch(function () { failed = true; });
        });
      });
      chain.then(function () {
        kinds.forEach(function (k) {
          var el = card(k);
          if (el) el.classList.remove('is-loading');
        });
        if (failed && errEl) errEl.hidden = false;
        if (uploaded.id && uploaded.body) {
          setState('pending');
        }
        updateSubmit();
      });
    }

    setState('loading');
    Promise.all([
      fetch(apiBase + '/api/v0/patient/id/verification' + idParams).then(function (r) { return r.json(); }),
      fetch(apiBase + '/api/v0/patient/properties' + idParams + '&field=body_picture').then(function (r) { return r.json(); })
    ]).then(function (results) {
      var idStatus = results[0].verificationStatus;
      var bodyStatus = results[1].body_picture;
      if (idStatus !== false) {
        uploaded.id = true;
        markUploaded('id');
      }
      if (bodyStatus !== false) {
        uploaded.body = true;
        markUploaded('body');
      }
      if (idStatus === true && bodyStatus === true) {
        setState('verified');
      } else if (idStatus === 'pending' && bodyStatus !== false) {
        setState('pending');
      } else {
        setState('missing');
      }
      updateSubmit();
    }).catch(function () {
      setState('missing');
      updateSubmit();
    });

    root.querySelectorAll('input[type="file"][data-kind]').forEach(function (input) {
      input.addEventListener('change', function () {
        var file = input.files[0];
        if (!file) return;
        stage(input.dataset.kind, file);
        input.value = '';
      });
    });

    if (submitBtn) submitBtn.addEventListener('click', submitAll);

    root.querySelectorAll('[data-staged-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var el = btn.closest('[data-uploader]');
        if (el) unstage(el.dataset.uploader);
      });
    });

    function acceptsFile(file) {
      return /^image\/(jpeg|png)$/.test(file.type) || file.type === 'application/pdf';
    }

    root.querySelectorAll('[data-uploader]').forEach(function (cardEl) {
      var blocked = function () {
        return cardEl.classList.contains('is-uploaded') || cardEl.classList.contains('is-loading');
      };
      ['dragenter', 'dragover'].forEach(function (evt) {
        cardEl.addEventListener(evt, function (e) {
          e.preventDefault();
          if (!e.dataTransfer) return;
          if (blocked()) {
            e.dataTransfer.dropEffect = 'none';
            return;
          }
          e.dataTransfer.dropEffect = 'copy';
          cardEl.classList.add('is-dragover');
        });
      });
      cardEl.addEventListener('dragleave', function (e) {
        if (!cardEl.contains(e.relatedTarget)) {
          cardEl.classList.remove('is-dragover');
        }
      });
      cardEl.addEventListener('drop', function (e) {
        e.preventDefault();
        cardEl.classList.remove('is-dragover');
        if (blocked() || !e.dataTransfer) return;
        var file = e.dataTransfer.files && e.dataTransfer.files[0];
        if (!file) return;
        if (!acceptsFile(file)) {
          window.alert(root.dataset.fileTypeError);
          return;
        }
        stage(cardEl.dataset.uploader, file);
      });
    });

    document.addEventListener('dragover', function (e) {
      e.preventDefault();
    });
    document.addEventListener('drop', function (e) {
      e.preventDefault();
    });

    var dialog = root.querySelector('[data-camera-dialog]');
    var camSupported = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && dialog && typeof dialog.showModal === 'function');
    if (camSupported) {
      root.querySelectorAll('[data-camera]').forEach(function (btn) {
        btn.hidden = false;
      });
      initCamera(root, dialog, stage);
    }
  }

  function initCamera(root, dialog, onPick) {
    var video = dialog.querySelector('.glp1-upload__video');
    var canvas = dialog.querySelector('.glp1-upload__canvas');
    var preview = dialog.querySelector('.glp1-upload__preview');
    var camError = dialog.querySelector('[data-camera-error-msg]');
    var btnCapture = dialog.querySelector('[data-cam-capture]');
    var btnUse = dialog.querySelector('[data-cam-use]');
    var btnRetake = dialog.querySelector('[data-cam-retake]');
    var btnCancel = dialog.querySelector('[data-cam-cancel]');
    var stream = null;
    var currentKind = null;
    var currentBlob = null;

    function stopStream() {
      if (stream) {
        stream.getTracks().forEach(function (t) { t.stop(); });
        stream = null;
      }
    }

    function showLive() {
      video.hidden = false;
      preview.hidden = true;
      camError.hidden = true;
      btnCapture.hidden = false;
      btnUse.hidden = true;
      btnRetake.hidden = true;
      if (preview.src) {
        URL.revokeObjectURL(preview.src);
        preview.removeAttribute('src');
      }
      currentBlob = null;
    }

    function showCamError() {
      video.hidden = true;
      preview.hidden = true;
      camError.hidden = false;
      btnCapture.hidden = true;
      btnUse.hidden = true;
      btnRetake.hidden = true;
    }

    root.querySelectorAll('[data-camera]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentKind = btn.dataset.camera;
        showLive();
        dialog.showModal();
        navigator.mediaDevices.getUserMedia({ video: true, audio: false })
          .then(function (s) {
            stream = s;
            video.srcObject = s;
          })
          .catch(function () {
            showCamError();
          });
      });
    });

    btnCapture.addEventListener('click', function () {
      if (!stream) return;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      canvas.toBlob(function (blob) {
        if (!blob) return;
        currentBlob = blob;
        preview.src = URL.createObjectURL(blob);
        video.hidden = true;
        preview.hidden = false;
        btnCapture.hidden = true;
        btnUse.hidden = false;
        btnRetake.hidden = false;
        stopStream();
      }, 'image/jpeg', 0.92);
    });

    btnRetake.addEventListener('click', function () {
      showLive();
      navigator.mediaDevices.getUserMedia({ video: true, audio: false })
        .then(function (s) {
          stream = s;
          video.srcObject = s;
        })
        .catch(function () {
          showCamError();
        });
    });

    btnUse.addEventListener('click', function () {
      if (!currentBlob || !currentKind) return;
      var name = currentKind === 'id' ? 'foto-id.jpg' : 'foto-koerper.jpg';
      var file;
      try {
        file = new File([currentBlob], name, { type: 'image/jpeg' });
      } catch (e) {
        file = currentBlob;
        file.name = name;
      }
      dialog.close();
      onPick(currentKind, file);
    });

    btnCancel.addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('close', function () {
      stopStream();
      showLive();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-glp1-upload]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cfg = document.querySelector('[data-landing-reveal]');
    if (!cfg || window.__p1RevealInit) return;
    window.__p1RevealInit = true;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var dist = parseInt(cfg.getAttribute('data-distance'), 10);
    var dur = parseInt(cfg.getAttribute('data-duration'), 10);
    if (isNaN(dist)) dist = 8;
    if (isNaN(dur)) dur = 600;
    document.documentElement.style.setProperty('--p1-reveal-dist', dist + 'px');
    document.documentElement.style.setProperty('--p1-reveal-dur', (dur / 1000) + 's');

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var all = document.querySelectorAll('[id^="shopify-section-template"]');
    var targets = [];
    for (var i = 0; i < all.length; i++) {
      var s = all[i];
      if (s.contains(cfg)) continue;
      var r = s.getBoundingClientRect();
      if (r.height > 0 && r.top > vh) targets.push(s);
    }
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) {
          entries[k].target.classList.add('is-visible');
          io.unobserve(entries[k].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    for (var j = 0; j < targets.length; j++) {
      targets[j].classList.add('p1-reveal');
      io.observe(targets[j]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-lp-theme"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observers = [];

    function forwardLinks() {
      var query = window.location.search.replace(/^\?/, '');
      if (!query) return;
      var links = document.querySelectorAll('[data-mlp-forward]');
      for (var i = 0; i < links.length; i++) {
        var base = links[i].getAttribute('data-mlp-base') || links[i].getAttribute('href');
        links[i].setAttribute('data-mlp-base', base);
        links[i].setAttribute('href', base + (base.indexOf('?') === -1 ? '?' : '&') + query);
      }
    }

    function initSticky() {
      observers.forEach(function (o) { o.disconnect(); });
      observers = [];
      var stickies = document.querySelectorAll('[data-mlp-sticky]');
      for (var i = 0; i < stickies.length; i++) {
        var sticky = stickies[i];
        var cta = sticky.closest('[data-mlp-hero-cta]');
        var btn = cta && cta.querySelector('.mlp-btn:not(.mlp-btn--sticky)');
        if (!btn || !('IntersectionObserver' in window)) { sticky.classList.add('is-visible'); continue; }
        (function (sticky, btn) {
          var o = new IntersectionObserver(function (entries) {
            var e = entries[entries.length - 1];
            sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
          o.observe(btn);
          observers.push(o);
        })(sticky, btn);
      }
    }

    function initReveal() {
      var roots = document.querySelectorAll('[data-mlp-anim]');
      if (!roots.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      for (var r = 0; r < roots.length; r++) {
        roots[r].classList.add('mlp--ready');
        var items = roots[r].querySelectorAll('[data-reveal]');
        for (var i = 0; i < items.length; i++) io.observe(items[i]);
      }
    }

    function initTimeline() {
      var lists = document.querySelectorAll('[data-mlp-anim] .mlp-tl');
      if (!lists.length) return;
      var ticking = false;
      function update() {
        ticking = false;
        var mid = window.innerHeight * 0.6;
        for (var i = 0; i < lists.length; i++) {
          var r = lists[i].getBoundingClientRect();
          var p = Math.min(1, Math.max(0, (mid - r.top) / r.height));
          lists[i].style.setProperty('--_tl-p', p.toFixed(3));
        }
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
      update();
    }

    function init() {
      try { forwardLinks(); } catch (e) {}
      try { initSticky(); } catch (e) {}
      try { initReveal(); } catch (e) {}
      try { initTimeline(); } catch (e) {}
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payment-explainer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(player) {
      if (player.dataset.payReady) return;
      player.dataset.payReady = '1';

      var video = player.querySelector('video[data-pay-ambient]');
      var btn = player.querySelector('[data-pay-play]');
      if (!video) return;

      video.muted = true;
      video.playsInline = true;

      function markPaused() { player.setAttribute('data-paused', ''); }
      function markPlaying() { player.removeAttribute('data-paused'); }

      function tryPlay() {
        var p = video.play();
        if (p && p.catch) p.catch(function () { markPaused(); });
      }

      video.addEventListener('play', markPlaying);
      video.addEventListener('pause', function () {
        if (video.dataset.payIoPause) {
          delete video.dataset.payIoPause;
          return;
        }
        markPaused();
      });

      if (btn) {
        btn.addEventListener('click', function () {
          delete video.dataset.payUserPaused;
          tryPlay();
        });
      }

      video.addEventListener('click', function () {
        if (video.paused) {
          delete video.dataset.payUserPaused;
          tryPlay();
        } else {
          video.dataset.payUserPaused = '1';
          video.pause();
        }
      });

      if (reduced.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        markPaused();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        tryPlay();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!video.dataset.payUserPaused) tryPlay();
          } else if (!video.paused) {
            video.dataset.payIoPause = '1';
            video.pause();
          }
        });
      }, { threshold: 0.3 });

      io.observe(video);
    }

    function init(root) {
      var players = (root || document).querySelectorAll('[data-pay-player]');
      for (var i = 0; i < players.length; i++) setup(players[i]);
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pill-pdp-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (!root || root.dataset.relInit) return;
      root.dataset.relInit = '1';
      var vp = root.querySelector('.pill-pdp-related__viewport');
      var nav = root.querySelector('.pill-pdp-related__nav');
      var prev = root.querySelector('[data-rel-prev]');
      var next = root.querySelector('[data-rel-next]');
      if (!vp || !nav || !prev || !next) return;

      function page() { return Math.max(160, Math.round(vp.clientWidth * 0.9)); }
      prev.addEventListener('click', function () { vp.scrollBy({ left: -page(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { vp.scrollBy({ left: page(), behavior: 'smooth' }); });

      function update() {
        var overflow = vp.scrollWidth - vp.clientWidth;
        if (overflow <= 2) { nav.style.display = 'none'; return; }
        nav.style.display = '';
        prev.disabled = vp.scrollLeft <= 2;
        next.disabled = vp.scrollLeft >= overflow - 2;
      }
      vp.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    function initAll() {
      document.querySelectorAll('.pill-pdp-related').forEach(initSlider);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector ? e.target.querySelector('.pill-pdp-related') : null;
      if (el) initSlider(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
